<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card v-if="data">
      <v-form ref="form" lazy-validation @submit.prevent="submitForm">
        <v-card-title
          >Pago
          {{
            data.payment === paymentMethodCash ? "en efectivo" : "por Datáfono"
          }}
          de: {{ formatPrice(data.amount) }}</v-card-title
        >
        <v-divider></v-divider>
        <br />

        <v-card-text class="grey--text">
          <v-row class="align-center">
            <v-col>
              <span class="text-h6"> Entregado por cliente: </span>
            </v-col>
            <v-col>
              <v-text-field
                :loading="loading"
                :disabled="loading"
                suffix="€"
                :rules="[rules.price]"
                v-model="inputAmount"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="data.payment === paymentMethodCash">
            <span class="ml-3 text-h6">Cambio: {{ change }}</span>
          </v-row>
        </v-card-text>

        <v-card-text class="text-center">
          <v-btn
            color="light"
            text
            :disabled="loading"
            style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
            @click="dialog = false"
          >
            <font-awesome-icon
              icon="times-circle"
              :style="{ color: '#ea2222', fontSize: 50 }"
            />
          </v-btn>

          <v-btn
            color="light"
            text
            type="submit"
            :disabled="loading"
            style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
          >
            <font-awesome-icon
              icon="check-circle"
              :style="{ color: '#11bd11', fontSize: 50 }"
            />
          </v-btn>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from "moment";
import firebaseMixin from "@/mixins/firebase/firebaseMixin";
import paymentsMixin from "@/mixins/payment/paymentsMixin";
import { firestoreTimestamp } from "@/firebaseConfig";
import { savePayment } from "@/collections/payments";
import { updateSetting } from "@/collections/settings";
import { saveOrder } from "@/collections/orders";
import {
  ordersTotalByTableCollection,
  updateOrderTotalByTable
} from "@/collections/ordersTotalByTable";
import axios from "axios";

export default {
  name: "PaymentReceipt",
  props: ["tableQR"],
  mixins: [firebaseMixin, paymentsMixin],
  data() {
    return {
      loading: false,
      dialog: false,
      data: {},
      inputAmount: 0,
      rules: {
        price: v =>
          (v !== undefined && parseFloat(v) > -1) ||
          "Por favor, introduce un Precio válido"
      }
    };
  },
  firestore() {
    return {
      ordersTotalByTable: ordersTotalByTableCollection
    };
  },
  computed: {
    change() {
      let change = parseFloat(this.inputAmount) - parseFloat(this.data.amount);
      if (change < 0) {
        change = 0;
      }
      return this.formatPrice(isNaN(change) ? 0 : change);
    },
    email() {
      return this.data?.company?.email;
    },
    maxInput() {
      const unpaidTotalPrice = parseFloat(
        this.data?.unpaidTotalPrice.toFixed(2)
      );
      return v =>
        this.data.payment !== this.paymentMethodCash
          ? parseFloat(v) <= unpaidTotalPrice ||
            "Por favor, introduce un Precio válido"
          : true;
    },
    getDrawerUrl() {
      return this.$store.state.selectedDrawer
        ? this.$store.state.selectedDrawer.url
        : "";
    }
  },
  methods: {
    open({
      amount,
      dividePayment,
      selectedProducts,
      payment,
      invoiceRequest,
      company,
      orders,
      unpaidTotalPrice
    }) {
      this.data = {
        amount,
        dividePayment,
        selectedProducts,
        payment,
        orders,
        invoiceRequest,
        company,
        unpaidTotalPrice
      };
      console.log(this.data);
      this.inputAmount = parseFloat(amount).toFixed(2);
      this.dialog = true;
    },
    async submitForm() {
      if (!this.$refs.form.validate()) return;
      let url = this.getDrawerUrl;
      try {
        this.loading = true;
        await this.openDrawer(url);
        await this.updateOrders();
        await this.savePayment();
        await this.saveOrderTotal();
        if (this.data.invoiceRequest) {
          await this.sendEmail();
        }
        this.dialog = false;
      } catch (error) {
        this.setlogError(
          "update_orders/save_payment/save_order_total",
          "Obtained error message in submitForm()",
          error.stack,
          this.$options.name
        );
      } finally {
        this.loading = false;
      }
    },
    async sendEmail() {
      let payment_on = moment().toDate();

      let baseUrl = this.projectUrl;
      let color = this.colorsGeneralPrimary;

      this.loading = true;

      await this.$api.admin.sendEmail({
        color: color,
        logo:
          this.settings && this.settings.icons ? this.settings.icons.logo : "",
        orders: JSON.stringify(this.data.orders),
        total: this.data.amount,
        amountPaid: parseFloat(this.inputAmount).toFixed(2),
        to: this.data.company.email,
        date: this.dayFormat2(payment_on),
        time: this.formatTime2(payment_on),
        subject: `Recibo de su pago a ${this.projectName}`,
        footerUrls: [
          {
            text: "Cookies",
            url: `${baseUrl}/cookies`
          },
          {
            text: "Privacidad",
            url: `${baseUrl}/privacy`
          },
          {
            text: "Términos y condiciones",
            url: `${baseUrl}/terms`
          },
          {
            text: "by aiwanna pay",
            url: `https://www.aiwannapay.com/`
          }
        ],
        invoiceRequest: this.data.invoiceRequest,
        legal_number:
          this.data.invoiceRequest === true ? this.data.legal_number : "",
        company: this.data.company,
        settings: this.settings,
        tableQR: this.tableQR,
        paymentMethod: this.data.payment,
        curr_language: this.$i18n.locale,
        email_trans: {
          mesa: this.$t("email.mesa") || "Mesa",
          product: this.$t("email.product") || "Producto",
          quantity: this.$t("email.quantity") || "Cantidad",
          price: this.$t("email.price") || "Precio",
          total: this.$t("email.total") || "Total de la cuenta",
          totalPaid: this.$t("email.totalPaid") || "Total Pagado",
          baseTax: this.$t("email.baseTax") || "Base imponible",
          VAT: this.$t("email.VAT") || "IVA",
          paymentMethod: this.$t("email.paymentMethod") || "Forma de pago",
          pagado: this.$t("email.pagado") || "Pagado"
        }
      });
    },
    async savePayment() {
      try {
        let payment_on = moment().toDate();
        let nextNumber = await this.getNextNumber();
        let nextInvoiceNumber =
          this.data.invoiceRequest === true
            ? await this.getNextInvoiceNumber()
            : "";

        let z_closure_id = await this.getzClosureIdAndUpdateWithPaymentMethodGiven(
          this.data.payment,
          false
        );
        let change =
          parseFloat(this.inputAmount) - parseFloat(this.data.amount);
        let now = moment().format();
        if (change < 0) {
          change = 0;
        }
        const payment = {
          tableQR: this.tableQR,
          orders: this.data.orders,
          receipt_is_sent: true,
          amount_paid_by_user:
            this.data.payment === this.paymentMethodCash
              ? parseFloat(this.data.amount).toFixed(2)
              : parseFloat(this.inputAmount).toFixed(2),
          payment_method: this.data.payment,
          cash_payment: {
            amount_paid:
              this.data.payment === this.paymentMethodCash
                ? parseFloat(this.inputAmount).toFixed(2)
                : null,
            change: this.formatPrice(change)
          },
          datafono_payment: {
            amount_paid:
              this.data.payment === this.paymentMethodDatafono
                ? parseFloat(this.inputAmount)
                : null
          },
          z_closure_id: z_closure_id,
          number: nextNumber,
          legal_number: this.data.invoiceRequest
            ? nextInvoiceNumber || nextNumber
            : nextNumber,
          payment_type: "amount",
          invoiceRequest: this.data.invoiceRequest,
          payment_on: payment_on,
          isAddedToSummary: false,
          updated_on: now
        };

        // actual payment done
        await savePayment(Date.now().toString(), payment);

        if (this.data.invoiceRequest) {
          payment.company = { ...this.data.company };
          delete payment.company.email;
          let data = this.settings;
          data.company.prev_inv_number = nextInvoiceNumber;

          await updateSetting("settings", data);
        }
      } catch (error) {
        this.setlogError(
          "update_setting/save_payment",
          "Obtained error message in SavePayment()",
          error.stack,
          this.$options.name
        );
      }
    },
    async updateOrders() {
      this.data.orders.forEach(async item => {
        if (
          this.data &&
          this.data.selectedProducts &&
          this.data.selectedProducts.length > 0
        ) {
          let found = this.data.selectedProducts.some(
            product => product.id === item.id
          );

          if (found && item.metadata) {
            // eslint-disable-next-line no-unused-vars
            for (const [quantity, metadata] of Object.entries(item.metadata)) {
              item.metadata[quantity].isPaid = true;
            }
          }
        } else {
          if (item.metadata) {
            // eslint-disable-next-line no-unused-vars
            for (const [quantity, metadata] of Object.entries(item.metadata)) {
              item.metadata[quantity].isPaid = true;
            }
          }
        }

        await saveOrder(item.id, item);
      });
    },
    async saveOrderTotal() {
      try {
        let time = firestoreTimestamp.fromDate(new Date());
        let orderByTotal = await this.ordersTotalByTable.find(
          x => x.id === this.tableQR
        );

        const amountPaid =
          this.data.payment === this.paymentMethodCash
            ? parseFloat(this.data.amount)
            : parseFloat(this.inputAmount);
        let remaining =
          parseFloat(orderByTotal.remaining).toFixed(2) -
          parseFloat(amountPaid).toFixed(2);

        if (remaining <= 0) {
          remaining = 0;
        }
        this.$emit("setRemaing", remaining);
        this.$emit("setOrders", this.data.orders);
        await updateOrderTotalByTable(this.tableQR, {
          tableQR: this.tableQR,
          remaining: parseFloat(remaining.toFixed(2)),
          time: time
        });
      } catch (error) {
        this.setlogError(
          "update_order_total_by_table",
          "Obtained error message in saveOrderTotal()",
          error.stack,
          this.$options.name
        );
      }
    },
    openDrawer(url) {
      axios
        .get(url)
        .then(async response => {
          if (response.status === 200 && response.data.result === true) {
            this.showSuccessMessage("Abriendo el cajón");
          } else {
            this.showErrorMessage("Error de conexión al abrir el cajón");
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(async () => {
          this.showErrorMessage("Error de conexión al abrir el cajón");
        });
    }
  }
};
</script>
